/* eslint-disable react/jsx-no-duplicate-props */
import React, { useEffect, useState } from "react";
import {
  Button,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalNext,
} from "@jutro/components";
import { useTranslator } from "@jutro/locale";
import _ from "lodash";
import PropTypes from "prop-types";
import { Stepper } from "@jutro/components/components/fields/Stepper/Stepper.js";
import { MLAgentChoiceReportService } from "gw-capability-gateway";
import { useAuthentication } from "@xengage/gw-digital-auth-react";
import styles from "./MLAdditionalCarrierPopup.module.scss";
import messages from "./MLAdditionalCarrierPopup.messages.js";

const MLAdditionalCarrierPopup = (props) => {
  const {
    title,
    isOpen,
    onReject,
    onResolve,
    updateAdditionalCarrier,
    accountNumber,
  } = props;
  const { loadReport } = MLAgentChoiceReportService();
  const { authHeader } = useAuthentication();

  const translator = useTranslator();

  const LOB_DATA = [
    {
      id: 1,
      name: "Auto",
      code: "A",
      product: "AUTO",
    },
    {
      id: 2,
      name: "Boat",
      code: "Y",
      product: "BOAT",
    },
    {
      id: 3,
      name: "Condo",
      code: "C",
      product: "CONDO",
    },
    {
      id: 4,
      name: "Landlord Condo",
      code: "C",
      product: "LL CONDO",
    },    
    {
      id: 5,
      name: "OWNER",
      code: "H",
      product: "OWNER",
    },
    {
      id: 6,
      name: "Landlord Dwelling",
      code: "H",
      product: "LL DWELLING",
    },
    {
      id: 7,
      name: "Rec Vehicle",
      code: "S",
      product: "REC VEHICLE",
    },    
    {
      id: 8,
      name: "Renter",
      code: "R",
      product: "RENTER",
    },
    {
      id: 9,
      name: "Umbrella",
      code: "U",
      product: "UMBRELLA",
    },
    {
      id: 10,
      name: "Mobile Home",
      code: "B",
      product: "MOBILEHOME",
    },
  ];

  const [quotes, setQuotes] = useState([]);
  const [applications, setapplications] = useState([]);

  useEffect(() => {
    const loadCarrierReportInfo = async () => {
      await loadReport(accountNumber, authHeader)
        .then((res) => {
          setQuotes(res.quotes);
          setapplications(res.applications);
        })
        .catch((err) => console.error("Load Report Error ", err));
    };

    loadCarrierReportInfo();

    return () => {
      setQuotes([]);
      setapplications([]);
    };
  }, []);

  const onChangeQuotesStepper = (event, lob) => {
    const count = Number(event.target.value);

    const quoteIndex = _.findIndex(
      quotes,
      (quote) => quote.profitCenter === lob.product
    );

    if (quoteIndex !== -1) {
      setQuotes(
        quotes.map((qt, index) =>
          index === quoteIndex
            ? { ...qt, count, profitCenter: lob.product }
            : qt
        )
      );

      return;
    }

    const newQuoteInfo = {
      count,
      lobCode: lob.code,
      profitCenter: lob.product,
    };

    setQuotes((qt) => [...qt, newQuoteInfo]);
  };

  const onChangeBoundCounter = (event, lob) => {
    const count = Number(event.target.value);

    const applicationIndex = _.findIndex(
      applications,
      (app) => app.profitCenter === lob.product
    );

    if (applicationIndex !== -1) {
      setapplications(
        applications.map((app, index) =>
          index === applicationIndex
            ? { ...app, count, profitCenter: lob.product }
            : app
        )
      );

      return;
    }

    const newApplicationInfo = {
      count,
      lobCode: lob.code,
      profitCenter: lob.product,
    };

    setapplications((app) => [...app, newApplicationInfo]);
  };

  const onSave = async () => {
    await updateAdditionalCarrier(quotes, applications);
    await onResolve();
  };

  const handleClose = () => {
    setQuotes([]);
    setapplications([]);

    onReject();
  };

  return (
    <ModalNext
      className={styles["ml-modal-dialog"]}
      isOpen={isOpen}
      onRequestClose={handleClose}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
    >
      <ModalHeader
        title={title}
        onClose={handleClose}
        contentLayout={{
          component: "div",
          componentProps: {
            className: styles["modal-header"],
          },
        }}
        titleLayout={{
          component: "flex",
          componentProps: {
            direction: "column",
            className: styles["modal-title"],
          },
        }}
      />
      <ModalBody
        contentLayout={{
          component: "div",
          componentProps: {
            className: styles["modal-body"],
          },
        }}
      >
        <div className={styles.quoteContainer}>
          <h4>{translator(messages.additionalCarriersQuoted)}</h4>
          <p> {translator(messages.partnerCarriersSelect)}</p>
          {LOB_DATA?.map((lob, index) => (
            <div key={index}>
              <Stepper
                id="quotesStepper"
                type="number"
                onChange={(event) => onChangeQuotesStepper(event, lob)}
                value={lob.value}
                step={1}
                label={lob.name}
                labelPosition="top"
                className={styles.stepper}
                min={
                  _.find(quotes, (quote) => quote.profitCenter === lob.product)
                    ?.count || 0
                }
                value={
                  _.find(quotes, (quote) => quote.profitCenter === lob.product)
                    ?.count || 0
                }
              />
            </div>
          ))}
        </div>
        <div className={styles.applicationContainer}>
          <h4 className={styles.alignmentalignment}>
            {translator(messages.additionalCarriersBound)}
          </h4>
          <p>{translator(messages.boundSelect)}</p>
          <p>{translator(messages.partnerCarriersSelect)}</p>
          {LOB_DATA?.map((bound, index) => (
            <div key={index}>
              <Stepper
                type="number"
                id="boundStepper"
                onChange={(event) => onChangeBoundCounter(event, bound)}
                value={bound.value}
                step={1}
                label={bound.name}
                labelPosition="top"
                min={
                  _.find(
                    applications,
                    (app) => app.profitCenter === bound.product
                  )?.count || 0
                }
                className={styles.stepper}
                value={
                  _.find(
                    applications,
                    (app) => app.profitCenter === bound.product
                  )?.count || 0
                }
              />
            </div>
          ))}
        </div>
      </ModalBody>
      <ModalFooter
        contentLayout={{
          component: "flex",
          componentProps: {
            className: styles["modal-footer"],
          },
        }}
      >
        <Button
          id="actionButton"
          type="filled"
          label={translator(messages.save)}
          onClick={onSave}
        >
          {translator(messages.save)}
        </Button>
        <Button
          id="cancelActionButton"
          onClick={handleClose}
          type="outlined"
          label={translator(messages.noChangesNeeded)}
        >
          {translator(messages.noChangesNeeded)}
        </Button>
      </ModalFooter>
    </ModalNext>
  );
};

MLAdditionalCarrierPopup.propTypes = {
  viewModel: PropTypes.shape({}).isRequired,
  viewModelService: PropTypes.shape({
    clone: PropTypes.func,
  }).isRequired,
  isOpen: PropTypes.bool,
  onReject: PropTypes.func,
  onResolve: PropTypes.func,

  onSaveAction: PropTypes.func,
  quoteID: PropTypes.string,
  getUnderlyingPolicies: PropTypes.func,
  isCompRaterQuote: PropTypes.bool,
};

export default MLAdditionalCarrierPopup;
